import {
  ALLOWED_CHAT_ASSET_MIME_TYPES,
  ALLOWED_CHAT_ASSET_TYPES,
} from "replo-utils/lib/assets";

export function isValidChatAssetType(file: File): boolean {
  if (ALLOWED_CHAT_ASSET_MIME_TYPES.includes(file.type)) {
    return true;
  }

  const extension = file.name.toLowerCase().split(".").pop();
  return extension ? ALLOWED_CHAT_ASSET_TYPES.includes(extension) : false;
}
